/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Risk_Write_HintInputs */



/**
* | output |
* | --- |
* | "Can change data in a system outside oneAI." |
*
* @param {Integrations_Risk_Write_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_risk_write_hint = /** @type {((inputs?: Integrations_Risk_Write_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Risk_Write_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kann Daten in einem System außerhalb von oneAI verändern.")
	return /** @type {LocalizedString} */ ("Can change data in a system outside oneAI.")
});